import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引用API文件
import api from '../assets/js/common/ServerInterface'

import {Message} from "element-ui";

import VueCookies from 'vue-cookies';

//Cookie
Vue.use(VueCookies)

// 将API方法绑定到全局
Vue.prototype.$api = api
Vue.prototype.$message = Message

Vue.use(require('vue-wechat-title'))

new Vue({
    router: router,//路由设置
    render: h => h(App)
}).$mount('#login')

